module.exports = {"attributes":{"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class='channel-icon-logo' fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M30.4 19.7H48L33.8 30l5.4 16.7L25 36.4l10-2.6-1.2-3.8-8.8 6.4-14.2 10.3L16.2 30 2 19.7h17.6L25 3l5.4 16.7z\" fill=\"#00B67A\"/>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/channel/trustpilot.svg
// module id = 1364
// module chunks = 0